// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ReturnCustomer snapshot 1`] = `
<div class="welcome">
  <fixedwidthtweakupper-stub>
    <sectionblock-stub nopadding="true">
      <welcomecustomer-stub></welcomecustomer-stub>
      <stylingproductsherobanner-stub></stylingproductsherobanner-stub>
    </sectionblock-stub>
    <!---->
    <!---->
    <!---->
    <!---->
    <!---->
    <!---->
    <sectionblock-stub class="color-bar-wrap">
      <div class="image-wrap xs-f-small md-f-small lg-f-large max-at-tweak">
        <img-box-stub mediaid="6250"></img-box-stub>
      </div>
      <div class="xs-12 md-7"></div>
      <div class="cta-wrap xs-12 md-5 text-center">
        <sectiontitle-stub text="Color Bar" class="color-bar-title"></sectiontitle-stub>
        <p class="xs-f-small max-at-tweak">Fast + Fabulous hair color with ingredients you can feel good about</p><a href="/colorbar/locations" class="mr-btn btn-fixed-width xs-f-xsmall max-at-tweak">Book Now</a><a href="/colorbar" class="block xs-f-small max-at-tweak">Learn more</a>
      </div>
    </sectionblock-stub>
    <expertiseincluded-stub></expertiseincluded-stub>
    <party-stub birthday="true" urlparam="bday" limitcookie="bday" class="birthday-confetti-vue">
      <div class="absolute-wrap">
        <div class="v-center full-width text-center">
          <p class="birthday-text semi-bold didot xs-f-xgrande md-f-xxxgrande lg-f-xxgrande max-at-tweak"><span class="upper">Happy Birthday</span><br>
            <!----><span class="script lower semi-bold color-purple xs-f-xgrande md-f-xxxgrande lg-f-xxgrande max-at-tweak">Beautiful<span class="normal xs-f-grande md-f-xxgrande lg-f-xgrande max-at-tweak">™</span></span></p>
        </div>
      </div>
    </party-stub>
  </fixedwidthtweakupper-stub>
</div>
`;
